import { createRouter, createWebHistory} from 'vue-router';

import PrimoStep from "@/components/PrimoStep";
import SecondoStep from "@/components/SecondoStep";
import TerzoStep from "@/components/TerzoStep";
import QuartoStep from "@/components/QuartoStep";
import QuintoStep from "@/components/QuintoStep";
import TicketEsistente from "@/components/TicketEsistente";
import RichiedenteStep6 from "@/components/RichiedenteStep6";
import RichiedenteStep7 from "@/components/RichiedenteStep7";
import RichiedenteStep8 from "@/components/RichiedenteStep8";
import ThankYou1 from "@/components/ThankYou1";
import erroreInserimento from "@/components/ErroreInserimento";
import PasseggeroAddizionale1 from "@/components/PasseggeroAddizionale1";
import PasseggeroAddizionale2 from "@/components/PasseggeroAddizionale2";
import A404Component from "@/components/A404Component";
import UltimoStep from "@/components/UltimoStep";
import DebugComponent from "@/components/DebugComponent";
import ErroreInserimento from "@/components/ErroreInserimento";
import DefaultRedirect from "@/components/DefaultRedirect";
const routes = [
    { path: '/', component: DefaultRedirect, name:'default',meta: { title : 'attivzione' } },
    { path: '/customers/:locale/flightsub/', component: PrimoStep, name:'step1',meta: { gtm: 'step1',title : 'Dati Volo' } },
    { path: '/customers/:locale/flightsub/volo/', component: SecondoStep, name:'step2', meta: { gtm: 'step2',title : 'Data Volo e Problematica' } },
    { path: '/customers/:locale/flightsub/infopersonali/', component: TerzoStep, name:'step3', meta: { gtm: 'step3', title : 'Dati Richiedente' }},
    { path: '/customers/:locale/flightsub/conferma/', component: QuartoStep, name:'step4', meta: { gtm: 'step4',title:'Riepilogo dati' }},
    { path: '/customers/:locale/flightsub/conclusione/', component: QuintoStep,name:'step5',meta: { gtm: 'ticketinserito', title:'Ticket inserito' }},
    { path: '/customers/:locale/flightsub/ticketesistente/', component: TicketEsistente,name:'ticketesistente',meta: { gtm: 'ticketesistente',title:'Ticket Esistente' }},
    { path: '/customers/:locale/flightsub/passdetail1/',component: RichiedenteStep6,name:'step6',meta: { gtm: 'flusso2_step1',title:'Dati passeggero - step 1' }},
    { path: '/customers/:locale/flightsub/passdetail2/',component: RichiedenteStep7,name:'step7',meta: { gtm: 'flusso2_step2' ,title:'Dati passeggero - step 2'}},
    { path: '/customers/:locale/flightsub/passdetail3/',component: RichiedenteStep8,name:'step8',meta: { gtm: 'flusso2_step3',title:'Dati passeggero - step 3' }},
    { path: '/customers/:locale/flightsub/psgsubcomplete/',component: ThankYou1,name:'thank1',meta: { gtm: 'flusso2_passeggero_inserito',title:'Passeggero inserito' }},
    { path: '/customers/:locale/flightsub/erroreinserimento/',component: erroreInserimento,name:'erroreinserimento',meta: { gtm: 'errore_inserimento',title:'Errore inserimento ticket' }},
    { path: '/customers/:locale/flightsub/newpssng1/',component: PasseggeroAddizionale1,name:'passeggero1',meta: { gtm: 'flusso2_nuovopasseggero_step1',title:'Dati passeggero aggiuntivo - step1' }},
    { path: '/customers/:locale/flightsub/newpssng2/',component: PasseggeroAddizionale2,name:'passeggero2',meta: { gtm: 'flusso2_nuovopasseggero_step2',title:'Dati passeggero aggiuntivo - step2' }},
    { path: '/customers/:locale/flightsub/fine',component:UltimoStep,name:'ultimostep',meta: { gtm: 'flusso2_processo_concluso' ,title:'Fine processo'}},
    { path: '/customers/:locale/flightsub/debug',component:DebugComponent,name:'debug'},
    { path: '/customers/:locale/flightsub/error',component:ErroreInserimento,name:'error',meta: { gtm: 'errore_generico',title:'Errore inaspettato' }},
    {
        path: '/:catchAll(.*)*',
        name: "PageNotFound",
        component: A404Component,
        meta: { gtm: 'pagina_non_trovata' }
    },
];


export default createRouter({
    history: createWebHistory(),
    routes,
});